import GatewayInstallState from './GatewayInstallState';
import DesiredGatewayInstallState from './DesiredGatewayInstallState';
export default {
  install(molten) {
    molten.addPlugin('Attribute', GatewayInstallState);
    molten.addPlugin('Attribute', DesiredGatewayInstallState);
  }
};